import React from 'react';
import ReactDOM from 'react-dom';
import { Loader2, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CancelConfirmModalProps {
  open: boolean;
  eventName?: string;
  marketName?: string;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const CancelConfirmModal: React.FC<CancelConfirmModalProps> = ({
  open,
  eventName,
  marketName,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[99]">
      <div className="bg-white p-5 rounded-lg shadow-xl w-[95%] max-w-md">
        <div className="flex justify-between gap-x-2 text-black">
          <h2 className="font-semibold text-black text-lg mb-2">Confirm Cancel</h2>
          <button onClick={onClose} className="self-start bg-primary-light rounded-full p-1 shadow">
            <X size={18} />
          </button>
        </div>

        <div className="text-sm text-black space-y-2">
          <p>Are you sure you want to cancel this market result?</p>
          <p className="font-medium text-gray-900">
            Event: <span className="font-semibold">{eventName || '-'}</span>
          </p>
          <p className="font-medium text-gray-900">
            Market: <span className="font-semibold">{marketName || '-'}</span>
          </p>
        </div>

        <div className="flex justify-end gap-2 mt-5">
          <Button type="button" variant="outline" onClick={onClose} disabled={isLoading}>
            Close
          </Button>
          <Button
            type="button"
            className="bg-red-600 hover:bg-red-700 text-white"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center gap-x-2">
                <span className="inline-block animate-spin">
                  <Loader2 className="w-5" />
                </span>
                Cancelling...
              </div>
            ) : (
              'Confirm'
            )}
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CancelConfirmModal;
